import {BaseView} from "../core/view"

export default BaseView.extend({
    
    filterType: undefined,
    filterData: undefined,
    initialActiveFilters: undefined,
    filterString: undefined,
    searchterm: undefined,
    firstLoad: undefined,

    events: {
        'click .js-select-filter' : 'onFilterCheck'
    },
    
    templates: {
        OPTION_FILTER_TEMPLATE: require("./templates/mobile-filter-option-template.hbs"),
    },

    stopPropagation: function(e) {
        e.stopPropagation();
    },
    
    onActiveFilterClick: function(data){
        this.manageFilterItem(data);
    },
    
    clearFilter: function(){
        this.filterData.active = false;
        this.fillList();
    },
    

    onFilterCheck: function(e) {
        e.preventDefault();
        var data = {
            filterType : this.$el.find(e.currentTarget).data("filter-type"),
            filterValue : this.$el.find(e.currentTarget).data("filter-value"),
            filterName : this.$el.find(e.currentTarget).data("filter-name").trim()
        };
        this.manageFilterItem(data);
        Backbone.trigger('applyMobileListFilter',data);
    },
    
    manageFilterItem: function(item){
        this.filterData.active = this.filterData.active == true ? false : true;
        this.fillList();
    },
    
    fillList: function(){
        var self = this;
        var activeList = self.filterData;
        
        var data = {
            name: self.filterString,
            url: activeList.url,
            active: activeList.active,
            visible: activeList.visible,
            filterType : self.filterType,
            id: self.filterType
        }
        
        var code = self.templates.OPTION_FILTER_TEMPLATE(data);
        
        if (this.firstLoad){
            if (activeList.active==true){
                var data = {
                    filterType : self.filterType,
                    filterValue : self.filterType,
                    filterName : self.filterString
                };
                Backbone.trigger('applyMobileListFilter',data);
            }
            
        }
        
        this.firstLoad = false;
        
        this.$el.html(code);
        
        
    },
    
    setActiveFilters: function(){
        // option active filter
        var self = this;
        if (self.initialActiveFilters.length>0){
            self.filterData.active = true;
        }
        
    },
    
    initialize: function(options) {
        this.firstLoad = true;
        this.filterType = options.filterType;
        this.filterData = options.filterData;
        this.filterString = options.filterString;
        this.initialActiveFilters = options.initialActiveFilters;
        this.setActiveFilters();
        this.fillList(this.filterData);
    }
    
});
